<template lang="">
    <v-app :lang="$i18n.locale">
    </v-app>
</template>
<script>
    import * as services from "@/services";
    import router from "@/router";
    export default {
        name: "ChangePasswordLanding",
        components: {},
        data: () => ({
            token: null,
        }),
        methods: {
            async validateChangePassword() {
                try {
                    const {data} = await services.getValidateChangePassword(this.token);
                    if(data.status == "ok"){
                        router.push({
                            path: `/account/change-password/${this.token}`,
                            
                        });
                    }
                    else{
                        router.push({
                            path: `/password_expired`
                        })
                    }
                } catch (err) {
                    if(err.response.status == 406){
                        router.push({
                            path: `/password_expired`
                        })
                    }
                    else{
                        window.location.href = '/error';
                        console.log("Route to 404 not found page")
                    }
                    
                }
            },
        },
        created(){
            this.token = this.$route.params.token
        },
        mounted() {
            this.validateChangePassword();
        },
    };
</script>
<style lang=""></style>
